// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-menu ion-content {
  --background: var(--ion-item-background, var(--ion-background-color, #fff));
}

.menuimg {
  width: 30px;
  margin-right: 24px;
}

.logo {
  width: 80px;
  margin: 0 auto;
  display: block;
}

.user_info {
  display: flex;
  align-items: center;
  position: relative;
  padding: 16px;
}
.user_info .back_image {
  height: 40px;
  width: 40px;
  min-width: 40px;
  border-radius: 100%;
  background: lightgrey;
}
.user_info ion-label {
  font-family: "semi-bold";
  margin-left: 16px;
}
.user_info ion-icon {
  position: absolute;
  right: 16px;
  color: grey;
}

.header_div {
  display: flex;
  align-items: center;
  padding: 16px;
  padding-right: 0px;
}
.header_div ion-label {
  color: grey;
  text-transform: uppercase;
  padding-right: 16px;
  font-size: 14px;
  white-space: nowrap;
}
.header_div div {
  width: 100%;
  height: 1px;
  background: lightgrey;
}

.image_div {
  padding-left: 16px;
  padding-right: 16px;
}

ion-item ion-label {
  font-family: "medium";
}
ion-item ion-label .menu-subtitle {
  display: block;
  color: #98a2b3;
  font-family: "regular";
  font-size: 10px;
}`, "",{"version":3,"sources":["webpack://./src/app/app.component.scss"],"names":[],"mappings":"AAAA;EACI,2EAAA;AACJ;;AAEA;EACI,WAAA;EACA,kBAAA;AACJ;;AAEA;EACI,WAAA;EACA,cAAA;EACA,cAAA;AACJ;;AAIA;EACI,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,aAAA;AADJ;AAGI;EACI,YAAA;EACA,WAAA;EACA,eAAA;EACA,mBAAA;EACA,qBAAA;AADR;AAII;EACI,wBAAA;EACA,iBAAA;AAFR;AAKI;EACI,kBAAA;EACA,WAAA;EACA,WAAA;AAHR;;AAOA;EACI,aAAA;EACA,mBAAA;EACA,aAAA;EACA,kBAAA;AAJJ;AAMI;EACI,WAAA;EACA,yBAAA;EACA,mBAAA;EACA,eAAA;EACA,mBAAA;AAJR;AAOI;EACI,WAAA;EACA,WAAA;EACA,qBAAA;AALR;;AASA;EACI,kBAAA;EACA,mBAAA;AANJ;;AAUI;EACI,qBAAA;AAPR;AASQ;EACI,cAAA;EACA,cAAA;EACA,sBAAA;EACA,eAAA;AAPZ","sourcesContent":["ion-menu ion-content {\n    --background: var(--ion-item-background, var(--ion-background-color, #fff));\n}\n\n.menuimg {\n    width: 30px;\n    margin-right: 24px;\n}\n\n.logo {\n    width: 80px;  //this for other app open\n    margin: 0 auto;\n    display: block;\n   // margin-bottom: -25px;  //this for other app  hide\n   // margin-top: -18px;  //this for other app hide\n}\n\n.user_info {\n    display: flex;\n    align-items: center;\n    position: relative;\n    padding: 16px;\n\n    .back_image {\n        height: 40px;\n        width: 40px;\n        min-width: 40px;\n        border-radius: 100%;\n        background: lightgrey;\n    }\n\n    ion-label {\n        font-family: 'semi-bold';\n        margin-left: 16px;\n    }\n\n    ion-icon {\n        position: absolute;\n        right: 16px;\n        color: grey;\n    }\n}\n\n.header_div {\n    display: flex;\n    align-items: center;\n    padding: 16px;\n    padding-right: 0px;\n\n    ion-label {\n        color: grey;\n        text-transform: uppercase;\n        padding-right: 16px;\n        font-size: 14px;\n        white-space: nowrap;\n    }\n\n    div {\n        width: 100%;\n        height: 1px;\n        background: lightgrey;\n    }\n}\n\n.image_div {\n    padding-left: 16px;\n    padding-right: 16px;\n}\n\nion-item {\n    ion-label {\n        font-family: 'medium';\n\n        .menu-subtitle {\n            display: block;\n            color: #98a2b3;\n            font-family: 'regular';\n            font-size: 10px;\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
